module.exports = __webpack_public_path__ + "img/商业建筑_02.1bec920c.png";